import type { Location } from 'modules/core/lib/navigation/types'

import { expensesNavigation as expenses } from 'modules/expenses/lib/navigation'
import { navigation as accounting } from 'modules/finance/lib/navigation/accounting'
import { navigation as contacts } from 'modules/finance/lib/navigation/contacts'
import { navigation as workspace } from 'modules/finance/lib/navigation/workspace'
import { navigation as oldBanking } from 'modules/finance/lib/old_navigation/banking'
import { navigation as oldCards } from 'modules/finance/lib/old_navigation/cards'
import { navigation as oldClients } from 'modules/finance/lib/old_navigation/clients'
import { navigation as oldContacts } from 'modules/finance/lib/old_navigation/contacts'
import { navigation as oldFinancialWorkspace } from 'modules/finance/lib/old_navigation/financial_workspace'
import { navigation as oldInvoices } from 'modules/finance/lib/old_navigation/invoices'
import { navigation as oldOverview } from 'modules/finance/lib/old_navigation/overview'
import { navigation as oldQuotes } from 'modules/finance/lib/old_navigation/quotes'
import { navigation as oldVendors } from 'modules/finance/lib/old_navigation/vendors'
import { navigation as oldWorkspace } from 'modules/finance/lib/old_navigation/workspace'
import { navigation as procurement } from 'modules/procurement/lib/navigation'
import { navigation as software } from 'modules/software_management/lib/navigation'

export const navigation = {
  path: 'finance',
  size: 'full',
  children: {
    // New modular navigation
    spending: {
      path: 'spending',
      size: 'full',
      children: {
        software: software,
        procurement: procurement,
        expenses: expenses,
        invoices: {
          path: 'invoices',
          size: 'full',
          children: {
            list: {
              path: 'list',
              size: 'full',
              children: {
                exporter: {
                  path: 'exporter',
                  size: 'full',
                },
                invoiceId: {
                  path: ':invoiceId',
                  size: 'full',
                  children: {
                    reconciliations: {
                      path: 'reconciliations',
                      size: 'full',
                    },
                  },
                },
              },
            },
            inbox: {
              path: 'inbox',
              size: 'full',
              children: {
                messageId: {
                  path: ':messageId',
                  size: 'full',
                },
              },
            },
          },
        },
        vendors: {
          path: 'vendors',
          size: 'full',
          children: contacts.children,
        },
      },
    },
    accounting: accounting,
    // scripts/generate_frontend_navigation.rb doesnt read imports in navigation files
    // so we need to explicit define the children here if we want them to be available in backend
    sales: {
      path: 'sales',
      size: 'full',
      children: {
        salesInvoices: {
          path: 'sales-invoices',
          size: 'full',
          children: {
            detail: {
              path: 'detail/:invoiceId',
              size: 'full',
              children: {
                documents: {
                  size: 'full',
                  path: 'documents',
                },
                overview: {
                  size: 'full',
                  path: 'overview',
                },
                form: {
                  path: 'form',
                  size: 'full',
                },
              },
            },
            create: {
              path: 'create',
              size: 'full',
            },
            invoiceId: {
              path: ':invoiceId',
              size: 'full',
            },
            exporter: {
              path: 'exporter',
              size: 'full',
            },
          },
        },
        quotes: {
          size: 'full',
          path: 'quotes',
          children: {
            quoteId: {
              size: 'full',
              path: ':quoteId',
              children: {
                pricing: {
                  size: 'full',
                  path: 'pricing',
                },
                details: {
                  size: 'full',
                  path: 'details',
                },
                edit: {
                  size: 'full',
                  path: 'edit',
                },
              },
            },
            new: {
              path: 'new',
            },
            detail: {
              path: 'detail/:quoteId',
              size: 'full',
            },
          },
        },
        deals: {
          size: 'full',
          path: 'deals',
          children: {
            dealId: {
              size: 'full',
              path: ':dealId',
              children: {
                details: {
                  size: 'full',
                  path: 'details',
                },
                quotes: {
                  size: 'full',
                  path: 'quotes',
                },
                invoices: {
                  size: 'full',
                  path: 'invoices',
                },
              },
            },
          },
        },
        clients: {
          size: 'full',
          path: 'clients',
          children: {
            exporter: {
              size: 'full',
              path: 'exporter',
            },
            contactId: {
              size: 'full',
              path: ':contactId',
              children: {
                edit: {
                  size: 'full',
                  path: 'edit',
                },
                overview: {
                  size: 'full',
                  path: 'overview',
                },
                projects: {
                  size: 'full',
                  path: 'projects',
                },
                purchaseOrders: {
                  size: 'full',
                  path: 'purchase-orders',
                },
                invoices: {
                  size: 'full',
                  path: 'invoices',
                },
                documents: {
                  size: 'full',
                  path: 'documents',
                },
                deals: {
                  size: 'full',
                  path: 'deals',
                },
                quotes: {
                  size: 'full',
                  path: 'quotes',
                },
                salesInvoices: {
                  size: 'full',
                  path: 'sales-invoices',
                },
              },
            },
          },
        },
      },
    },
    treasury: {
      path: 'treasury',
      size: 'full',
      children: {
        overview: {
          path: 'overview',
          size: 'full',
        },
        banking: {
          path: 'banking',
          children: {
            accounts: {
              path: 'accounts',
              size: 'full',
              children: {
                accountId: {
                  path: ':id',
                  size: 'full',
                  children: {
                    transactions: {
                      path: 'transactions',
                      size: 'full',
                      children: {
                        transactionId: {
                          path: ':transaction_id',
                          size: 'full',
                        },
                      },
                    },
                    cards: {
                      path: 'cards',
                      size: 'full',
                      children: {
                        cardId: {
                          path: ':card_id',
                          size: 'full',
                        },
                      },
                    },
                    card_payments: {
                      path: 'card_payments',
                      size: 'full',
                    },
                    reconciliations: {
                      path: 'reconciliations',
                      size: 'full',
                      children: {
                        new: {
                          path: 'new',
                          size: 'full',
                        },
                      },
                    },
                  },
                },
              },
            },
            onboardings: {
              path: 'onboardings',
              size: 'full',
            },
            payments: {
              path: 'payments',
              size: 'full',
              children: {
                paymentId: {
                  path: 'bulk-payments/:id',
                  size: 'full',
                },
                transfers: {
                  path: 'transfers',
                  size: 'full',
                },
                paymentRequests: {
                  path: 'payment-requests',
                  size: 'full',
                  children: {
                    paymentRequestId: {
                      path: ':paymentRequestId',
                      size: 'full',
                    },
                  },
                },
              },
            },
            cards: {
              path: 'cards',
              size: 'full',
              children: {
                list: {
                  path: 'list',
                  size: 'full',
                },
                cardId: {
                  path: ':cardId',
                  level: 2,
                },
              },
            },
          },
        },
      },
    },
    financialWorkspace: workspace,

    // Old navigation. We intentionally dont want it to be available in backend so we add it as separate files
    financial_workspace: oldFinancialWorkspace,
    workspace: oldWorkspace,
    clients: oldClients,
    vendors: oldVendors,
    contacts: oldContacts,
    quotes: oldQuotes,
    cards: oldCards,
    banking: oldBanking,
    overview: oldOverview,
    invoices: oldInvoices,
  },
} as const satisfies Location

export const mySpending = {
  path: 'my-spending',
  size: 'full',
} as const satisfies Location
